<template>
	<div class="wrap">
		<div class="tab">
			<el-tabs v-model="activeName" @tab-click="handleClick">
				<el-tab-pane label="基本信息" name="0" />
				<el-tab-pane label="展会介绍" name="1" />
				<el-tab-pane label="展馆展览" name="2" />
				<el-tab-pane label="参观指引" name="3" />
				<el-tab-pane label="参展手册" name="4" />
				<el-tab-pane label="联系我们" name="5" />
				<el-tab-pane label="合作伙伴" name="6" />
			</el-tabs>
		</div>
		<router-view  @eventForm="handleGetForm"></router-view>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				tabList: [],
				exhibition_id:'',
				activeName: this.$route.name.charAt(this.$route.name.length - 1),
				id:'',
			}
		},
		beforeCreate() {
			if(this.$route.query.id > 0){
				this.exhibition_id = this.$route.query.id
			}
		},
		methods: {
			handleClick(tab, event) {
				if(this.$route.query.id > 0){
					this.$router.push({path: '/expo/e' + this.activeName, query: {id:this.$route.query.id}});
				}else{
					this.$message({
						type: 'error',
						message: '请先填写基本信息'
					})
				}
			},
			//提交表单
			handleGetForm(form){
				this.$axios.post('Exhibition-Admin-addSaveExhibitionShopInfo',form).then(data => {
					if(typeof(data) == 'string'){
						this.$route.query.id = data
					}
					this.$message({
						type: 'success',
						message: '成功~'
					})
					
				})
			}
		}
	}
</script>

<style scoped>
	.tab {
		padding: 0 28px;
		border-bottom: 1px solid #ebebeb;
		overflow: hidden;

	}

	.tab>>>.el-tabs__item {
		height: 60px;
		line-height: 60px;
	}

	.tab>>>.el-tabs__header {
		margin: 18px 0 0 0;
	}

	.form {
		padding: 45px 28px 0;
		overflow: hidden;
	}

	.form>>>.el-form-item__label {
		color: #333;
	}

	.form>>>.el-input:not(.el-input--suffix) .el-input__inner {
		width: 600px;
	}

	.form>>>.el-textarea__inner {
		width: 600px;
	}

	.form>>>.submit-btn {
		width: 80px;
		height: 32px;
		line-height: 32px;
		text-align: center;
		color: #fff;
		background: #0f69dc;
		margin: 110px auto;
		border-radius: 5px;
		cursor: pointer;
	}

	.center {
		margin-left: 69px;
	}

	.form>>>.subTit {
		font-size: 14px;
		color: #333333;
		margin: 0 0 37px 37px;
	}
</style>
